import request from '@/utils/request';

/**
 *  用户信息接口
 * @returns {{getUserInfo: (function(*=): *)}}
 */
export function OrderApi () {
  return {
    //订单列表
    getOrderList: params => {
      return request ({
        url: '/admin/orders/index',
        method: 'get',
        params,
      });
    },
    //导出订单
    getOrderexport: params => {
      return request ({
        url: '/admin/orders/export',
        method: 'get',
        params,
      });
    },
    //提现列表
    getOrderwithdraw: params => {
      return request ({
        url: '/admin/withdraw/index',
        method: 'get',
        params,
      });
    },
    //待提现信息
    getOrderinfo: params => {
      return request ({
        url: '/admin/withdraw/info',
        method: 'get',
        params,
      });
    },
    //申请提现
    getOrderadd: params => {
      return request ({
        url: '/admin/withdraw/add?money='+params,
        method: 'post',
      });
    },
    //提现订单
    getOrderDingdan: params => {
      return request ({
        url: '/admin/withdraw/orders',
        method: 'get',
        params,
      });
    },
    //打款列表
    getOrdercwindex: params => {
      return request ({
        url: '/admin/withdraw/cwindex',
        method: 'get',
        params,
      });
    },
    //打款列表导出
    getOrdercwexport: params => {
      return request ({
        url: '/admin/withdraw/cwexport',
        method: 'get',
        params,
      });
    },
    //打款列表详情
    getOrdershow: params => {
      return request ({
        url: '/admin/withdraw/show?id='+params,
        method: 'get',
      });
    },
    //编辑打款信息
    getOrderedit: params => {
      return request ({
        url: '/admin/withdraw/edit',
        method: 'post',
        params,
      });
    },

    //字节退款
    refundByte: params => {
      return request ({
        url: '/admin/orders/refund/byte',
        method: 'post',
        params,
      });
    },
  };
}
